const doc = [({"da":({"js":({"live_streaming_feeds":({"viewer":({"speaker_isnt_broadcasting":"Taler sender ikke i øjeblikket."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;